import React, { useContext, useState } from "react";
import FormTriggers from "../../../layouts/FormTriggers";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import { ownershipOptions } from "../../../utils/constant";
import RadioButtons from "../../../layouts/RadioButtons";
import { axios_instance } from "../../../api/axios_instance";
import FormButtons from "./FormButtons";
import { toast } from "react-toastify";
import {
  checkHoldCase,
  getCompletedStepDetails,
  holdCaseMessage,
  ownershipFormValidate,
} from "../../../utils/detail";
import { DetailFormContext } from "../../../ContextAPI/context";

const Ownership = ({
  fieldValues,
  stepSelected,
  handleNextStep,
  user,
  isVerificationRequired,
  Message,
  dtsCheckpoints,
  fetchCaseData,
  caseDetails,
}) => {
  const { panelTitle, stepTitle, setDetailFormButtonClicked } =
    useContext(DetailFormContext);
  const { stepDetails, visibilityObj, requiredSubStepFields } = fieldValues;
  const { checklist, btnDraftType } = stepDetails;
  const {
    finance_lead_id,
    id,
    is_original_rc,
    original_rc_mismatch,
    is_fir_copy,
    is_form_26,
    is_form_29,
    ownership,
    blacklist,
    regno,
    chassis_number,
    engine_no,
    stage,
    sub_stage,
    insurance,
    bank_id,
    is_prepayment_raised,
    step_details,
    maker_id,
  } = caseDetails;

  const originalRC =
    parseInt(is_original_rc) === 0 || is_original_rc
      ? is_original_rc
      : original_rc_mismatch;

  const initialState = {
    originalRC,
    ownership,
    isFirCopy: is_fir_copy,
    isForm26: is_form_26,
    isForm29: is_form_29,
    showOriginalRCError: false,
    showOwnershipError: false,
    showIsFirCopyError: false,
    showIsForm26Error: false,
  };
  const [state, setState] = useState(initialState);

  const firCheck =
    state.originalRC == null ||
    state.originalRC === "" ||
    +state.originalRC === 1
      ? true
      : false;

  // Check visibility conditions for each field
  const isOriginalRcVisible =
    requiredSubStepFields?.original_rc?.is_visible === 1;
  const isFirCopyVisible =
    !firCheck && requiredSubStepFields?.fir_copy?.is_visible === 1;
  const isForm26Visible =
    !firCheck && requiredSubStepFields?.form_26?.is_visible === 1;
  const isForm29Visible =
    requiredSubStepFields?.form_29_30?.is_visible === 1 &&
    visibilityObj.is_form_29;
  const isBlacklistVisible = requiredSubStepFields?.blacklist?.is_visible === 1;
  const isCurrentOwnerVisible =
    requiredSubStepFields?.current_owner?.is_visible === 1;
  const isRegNoVisible = requiredSubStepFields?.reg_no?.is_visible === 1;
  const isChassisNoVisible =
    requiredSubStepFields?.chassis_no?.is_visible === 1;
  const isEngineNoVisible = requiredSubStepFields?.engine_no?.is_visible === 1;

  // Check if any field requires verification
  const calculatedIsVerificationRequired =
    isOriginalRcVisible ||
    isFirCopyVisible ||
    isForm26Visible ||
    isForm29Visible ||
    isBlacklistVisible ||
    isCurrentOwnerVisible ||
    isRegNoVisible ||
    isChassisNoVisible ||
    isEngineNoVisible;

  const saveDetails = async () => {
    try {
      const stepDetails = getCompletedStepDetails(
        step_details,
        sub_stage,
        stepSelected
      );
      await axios_instance({
        url: "/dts/dtsAdditionalDetails",
        method: "POST",
        data: {
          finance_lead_id: +finance_lead_id,
          form: stepSelected,
          stage: +stage,
          sub_stage: +sub_stage,
          type: btnDraftType,
          step_details: stepDetails,
          insurance,
          bank_id,
          is_prepayment_raised,
          original_rc: state.originalRC,
          ownership: state.ownership,
          is_fir_copy: state.isFirCopy,
          is_form_26: state.isForm26,
          is_form_29: state.isForm29,
          disbursement_id: +id,
        },
      });
      await fetchCaseData();
    } catch (error) {}
  };

  const handleSaveAndNext = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (
        !ownershipFormValidate(state, setState, firCheck, requiredSubStepFields)
      ) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
      handleNextStep();
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleSaveAsDraft = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (
        !ownershipFormValidate(state, setState, firCheck, requiredSubStepFields)
      ) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleInputChange = (inputName, value, errorId) => {
    if (!errorId) {
      return setState({ ...state, [inputName]: value });
    }
    setState({ ...state, [inputName]: value, [errorId]: false });
  };

  return (
    <>
      <div
        className="table-responsive chklist-box-scroll mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        data-mcs-theme="minimal-dark"
      >
        {isVerificationRequired && calculatedIsVerificationRequired ? (
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            >
              <form id="ownership">
                <table className="table table-bordered disburse-table">
                  <thead>
                    <tr>
                      <th width="76%" colSpan="2">
                        {panelTitle} - {stepTitle}
                      </th>
                      {checklist && <th width="24%">L1</th>}
                    </tr>
                  </thead>
                  <tbody className="form-table">
                    {isOriginalRcVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.original_rc?.name}
                          isRequired={true}
                          className="rto"
                          name="original_rc"
                          disabled={
                            requiredSubStepFields?.original_rc?.is_editable ===
                            1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.originalRC === 1 ? true : false}
                          noChecked={state.originalRC === 0 ? true : false}
                          onYesClicked={() =>
                            handleInputChange(
                              "originalRC",
                              1,
                              "showOriginalRCError"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "originalRC",
                              0,
                              "showOriginalRCError"
                            )
                          }
                          showError={state.showOriginalRCError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="original_rc"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isFirCopyVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.fir_copy?.name}
                          isRequired={!firCheck}
                          className="rto"
                          name="fir_copy"
                          disabled={
                            requiredSubStepFields?.fir_copy?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isFirCopy === 1 ? true : false}
                          noChecked={state.isFirCopy === 0 ? true : false}
                          onYesClicked={() =>
                            handleInputChange(
                              "isFirCopy",
                              1,
                              "showIsFirCopyError"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "isFirCopy",
                              0,
                              "showIsFirCopyError"
                            )
                          }
                          showError={state.showIsFirCopyError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="fir_copy"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isForm26Visible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.form_26?.name}
                          isRequired={!firCheck}
                          className="rto"
                          name="is_form_26"
                          disabled={
                            requiredSubStepFields?.form_26?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isForm26 === 1 ? true : false}
                          noChecked={state.isForm26 === 0 ? true : false}
                          onYesClicked={() =>
                            handleInputChange(
                              "isForm26",
                              1,
                              "showIsForm26Error"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "isForm26",
                              0,
                              "showIsForm26Error"
                            )
                          }
                          showError={state.showIsForm26Error}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="is_form_26"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isForm29Visible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.form_29_30?.name}
                          isRequired={false}
                          className="rto"
                          name="is_form_29"
                          disabled={
                            requiredSubStepFields?.form_29_30?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isForm29 === 1 ? true : false}
                          noChecked={state.isForm29 === 0 ? true : false}
                          onYesClicked={() =>
                            setState({ ...state, isForm29: 1 })
                          }
                          onNoClicked={() =>
                            setState({ ...state, isForm29: 0 })
                          }
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="is_form_29"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isBlacklistVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.blacklist?.name}</td>
                        <td>
                          <span>
                            <label>{blacklist ? "Yes" : "No"}</label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="blacklist"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isCurrentOwnerVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.current_owner?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <span>
                            <SingleSelectDropDown
                              dataArr={ownershipOptions}
                              handleChange={(e) =>
                                handleInputChange(
                                  "ownership",
                                  e.target.value,
                                  "showOwnershipError"
                                )
                              }
                              name="ownership"
                              disabled={
                                requiredSubStepFields?.current_owner
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              required={true}
                              value={state.ownership}
                              className={
                                state.showOwnershipError ? "errorInput" : ""
                              }
                              divClassName="form-group payment-dropdown-tranche-form"
                            />
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="ownership"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isRegNoVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.reg_no?.name}</td>
                        <td>
                          <span>
                            <label>{regno}</label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="reg_no"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isChassisNoVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.chassis_no?.name}</td>
                        <td>
                          <span>
                            <label>{chassis_number}</label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="chassis"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isEngineNoVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.engine_no?.name}</td>
                        <td>
                          <span>
                            <label>{engine_no}</label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="engine"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        ) : (
          <div className="disburse-table no-form">
            There are no verification required in this section. Please click
            Next/Skip to proceed
          </div>
        )}
      </div>
      <FormButtons
        caseDetails={caseDetails}
        user={user}
        stepDetails={stepDetails}
        handleNextButtonClick={handleNextStep}
        handleSaveAndNext={handleSaveAndNext}
        handleSaveAsDraft={handleSaveAsDraft}
        isVerificationRequired={calculatedIsVerificationRequired}
        isReadOnlyUser={fieldValues.isReadOnlyUser}
      />
    </>
  );
};

export default Ownership;
